(() => {
  const phone = window.matchMedia('(max-width: 749px)');
  function init(root) {
    if (!root || root.dataset.phoneReady) return;
    root.dataset.phoneReady = 'true';
    const undo = [];
    const quiz = root.querySelector('#ch-quiz');
    const products = JSON.parse(quiz?.dataset.phoneProducts || '{}');
    const labels = JSON.parse(quiz?.dataset.phoneLabels || '{}');
    let active = false;
    let result = null;
    let resetResult = () => {};
    const find = selector => root.querySelector(selector);
    function copy(element, value) {
      if (!element || !value) return;
      const original = [...element.childNodes];
      element.textContent = value;
      undo.push(() => element.replaceChildren(...original));
    }
    function attribute(element, name, value) {
      if (!element) return;
      const original = element.getAttribute(name);
      element.setAttribute(name, value);
      undo.push(() => original === null ? element.removeAttribute(name) : element.setAttribute(name, original));
    }
    function move(element, parent, before = null) {
      if (!element || !parent) return;
      const marker = document.createComment('phone position');
      element.before(marker);
      parent.insertBefore(element, before);
      undo.push(() => marker.replaceWith(element));
    }
    function reviewLink(element, href) {
      if (!element || !href) return;
      const link = document.createElement('a');
      link.className = element.className;
      link.href = href;
      link.textContent = element.textContent;
      element.replaceWith(link);
      undo.push(() => link.replaceWith(element));
    }
    function updateResult() {
      resetResult();
      resetResult = () => {};
      if (!active || !result || result.managed) return;
      const product = products[result.winner];
      const link = find('#ch-qres-link');
      if (!product?.url || !link) return;
      link.textContent = product.available ? `${labels.details} · ${product.price}` : labels.notify;
      link.href = product.url;
      if (!product.available) {
        link.dataset.homePhoneWaitlistName = product.name;
        link.dataset.homePhoneWaitlistHandle = product.handle;
      }
      const stock = document.createElement('p');
      stock.className = 'kh-phone-quiz-stock';
      stock.textContent = `${product.price} · ${product.available ? labels.available : labels.soldOut}`;
      find('.ch-quiz__res-actions').before(stock);
      let details;
      if (!product.available) {
        details = document.createElement('a');
        details.href = product.url;
        details.className = 'kh-phone-product-details';
        details.textContent = labels.details;
        find('.ch-quiz__res-actions').after(details);
      }
      const current = result;
      resetResult = () => {
        link.textContent = current.cta;
        link.setAttribute('href', current.href);
        delete link.dataset.homePhoneWaitlistName;
        delete link.dataset.homePhoneWaitlistHandle;
        stock.remove();
        details?.remove();
      };
    }
    function sync() {
      if (active === phone.matches) return;
      active = phone.matches;
      document.body.classList.toggle('kh-phone-home', active);
      if (!active) {
        resetResult();
        resetResult = () => {};
        while (undo.length) undo.pop()();
        return;
      }
      root.querySelectorAll('[data-home-phone-copy]').forEach(element => copy(element, element.dataset.homePhoneCopy));
      const balm = find('.ch-cream__content');
      move(find('.ch-cream__meta'), balm, find('.ch-cream__sub'));
      move(find('.ch-cream__actions'), balm, find('.ch-cream__ticks'));
      move(find('.ch-cream__content .kh-phone-product-details'), balm, find('.ch-cream__ticks'));
      reviewLink(find('.ch-balm-rating'), products.precision?.url ? `${products.precision.url}#reviews` : null);
      const science = find('.ch-science-film__layout');
      if (science) {
        const heading = document.createElement('div');
        heading.className = 'kh-phone-science-heading';
        science.prepend(heading);
        undo.push(() => heading.remove());
        move(find('.ch-science-intro .ch-sec-label'), heading);
        move(find('.ch-science-intro .ch-sec-head'), heading);
        move(find('.ch-science-intro .ch-sec-sub'), heading);
        move(find('.ch-science-intro .ch-benefits__intro-link'), find('.ch-science-intro'));
      }
      root.querySelectorAll('.ch-science-tile img').forEach(img => attribute(img, 'alt', ''));
      const film = find('[data-science-film] video');
      const filmLabels = find('[data-home-film-toggle]');
      if (film && filmLabels) {
        const toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'kh-phone-film-toggle';
        toggle.setAttribute('aria-controls', film.id);
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        let pausedByUser = reduced.matches;
        const label = () => {
          toggle.textContent = film.paused ? filmLabels.dataset.play : filmLabels.dataset.pause;
          toggle.hidden = film.controls;
        };
        const onPlay = () => { if (pausedByUser) film.pause(); label(); };
        const onMotion = () => { if (reduced.matches) { pausedByUser = true; film.pause(); } label(); };
        toggle.addEventListener('click', () => {
          pausedByUser = !film.paused;
          if (pausedByUser) film.pause();
          else film.play().catch(label);
          label();
        });
        film.addEventListener('play', onPlay);
        film.addEventListener('pause', label);
        reduced.addEventListener('change', onMotion);
        film.closest('[data-science-film]').append(toggle);
        label();
        undo.push(() => {
          film.removeEventListener('play', onPlay);
          film.removeEventListener('pause', label);
          reduced.removeEventListener('change', onMotion);
          toggle.remove();
        });
      }
      const trio = find('.ch-trio__content');
      move(find('.ch-trio__pricing'), trio, find('.ch-trio__desc'));
      move(find('.ch-trio__actions'), trio, find('.ch-trio__products'));
      move(find('.ch-trio__trust'), trio, find('.ch-trio__products'));
      const shortNames = labels.shortNames || [];
      root.querySelectorAll('.ch-trio__prod-name').forEach((element, index) => copy(element, shortNames[index]));
      root.querySelectorAll('.ch-trio__prod-detail').forEach(element => copy(element, element.textContent.split('·').pop().trim()));
      const firstFaq = find('#koppa-home-faq details');
      if (firstFaq && !firstFaq.closest('.ploy-native')) {
        const wasOpen = firstFaq.open;
        firstFaq.open = false;
        undo.push(() => { firstFaq.open = wasOpen; });
      }
      root.querySelectorAll('#home .ch-herocar__ctas a').forEach(link => {
        if (link.getAttribute('href') === '/pages/find-your-routine') attribute(link, 'href', '#home-quiz');
      });
      updateResult();
    }
    function onResult(event) {
      resetResult();
      resetResult = () => {};
      result = event.detail;
      const link = find('#ch-qres-link');
      if (link) { link.textContent = result.cta; link.setAttribute('href', result.href); }
      updateResult();
    }
    function onReset() { resetResult(); resetResult = () => {}; result = null; }
    function onWaitlist(event) {
      if (!active || typeof window.koppaOpenWaitlist !== 'function') return;
      const trigger = event.target.closest('[data-home-phone-waitlist-handle]');
      if (!trigger || !root.contains(trigger)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      window.koppaOpenWaitlist({name: trigger.dataset.homePhoneWaitlistName, handle: trigger.dataset.homePhoneWaitlistHandle});
    }
    root.addEventListener('click', onWaitlist, true);
    root.addEventListener('koppa:quiz-result', onResult);
    root.addEventListener('koppa:quiz-reset', onReset);
    phone.addEventListener('change', sync);
    sync();
    function onUnload(event) {
      if (event.target !== root && !event.target.contains(root)) return;
      resetResult();
      while (undo.length) undo.pop()();
      phone.removeEventListener('change', sync);
      root.removeEventListener('click', onWaitlist, true);
      root.removeEventListener('koppa:quiz-result', onResult);
      root.removeEventListener('koppa:quiz-reset', onReset);
      document.body.classList.remove('kh-phone-home');
      document.removeEventListener('shopify:section:unload', onUnload);
    }
    document.addEventListener('shopify:section:unload', onUnload);
  }
  init(document.querySelector('.shopify-section.koppa-home-system'));
  document.addEventListener('shopify:section:load', event => init(event.target.matches('.koppa-home-system') ? event.target : event.target.querySelector('.koppa-home-system')));
})();
